import { green, orange, red } from "./helper/getColor";

export const getInitials = (text) => {
  if (!text) return "";
  const found = text.match(/\b[a-zA-Z]/g);
  return found.join("");
};

export const groupBy = (items, key, callback) => {
  const groups = items.reduce(
    (result, item) => ({
      ...result,
      [item[key]]: [...(result[item[key]] || []), item],
    }),
    {}
  );
  callback(groups);
};

export const getQueryStringValue = (key) => {
  return decodeURIComponent(
    window.location.search.replace(
      new RegExp(
        "^(?:.*[&\\?]" +
          encodeURIComponent(key).replace(/[\.\+\*]/g, "\\$&") +
          "(?:\\=([^&]*))?)?.*$",
        "i"
      ),
      "$1"
    )
  );
};

export const getGradeId = (grade) => {
  const gradeInt = parseInt(grade);
  if (gradeInt >= 1 && gradeInt <= 4) {
    return 2;
  } else if (gradeInt >= 5 && gradeInt <= 7) {
    return 5;
  } else if (gradeInt >= 8 && gradeInt <= 10) {
    return 8;
  } else {
    return 12;
  }
};

export const getLevel = (gradeId) => {
  const gd = parseInt(gradeId);
  const level = gd === 2 ? "1" : gd === 5 ? "2" : gd === 8 ? "3" : "4";
  return level;
};

export const getNumberOfStars = (std, callback, type) => {
  const arr = [];

  // callback has to be getTextColor from the helper/getColor.js

  const color = type === "flags" ? red : green;

  new Array(1, 1, 1, 1, 1).forEach((el, i) => {
    if (
      std[`mappr${i + 1}_max_score`] === "0" ||
      std[`mappr${i + 1}_max_score`] === "NA"
    ) {
      arr.push(null);
    } else {
      arr.push(
        callback(
          std[`mappr${i + 1}_score`],
          std[`mappr${i + 1}_cutscore1`],
          std[`mappr${i + 1}_cutscore2`]
        )
      );
    }
  });
  return arr.filter((el) => el === color).length;
};
